module.exports = __webpack_public_path__ + "img/star.c7df9011.png";